import React, { useState } from "react";
import miLogo from "./logo-sintergia.png";

export default function App() {
  // --- ESTADOS ORIGINALES ---
  const [modoCalculo, setModoCalculo] = useState("recibo"); // recibo, cargas, almacenamiento
  const [cliente, setCliente] = useState("");
  const [primerNombre, setPrimerNombre] = useState("");
  const [colonia, setColonia] = useState("");
  const [ubicacion, setUbicacion] = useState("Obregón");
  const [tarifa, setTarifa] = useState("1F");
  const [montoActual, setMontoActual] = useState("");
  const [tipoPeriodo, setTipoPeriodo] = useState("Bimestral");
  const [periodos, setPeriodos] = useState(["", "", "", "", "", ""]);
  const [bloquesConsumo, setBloquesConsumo] = useState([]);
  const [scanStatus, setScanStatus] = useState("");

  const [cargas, setCargas] = useState([
    {
      id: 1,
      aparato: "Minisplit 1 Ton Inverter",
      cantidad: 3,
      watts: 812,
      horas: 8,
      mesesAno: 6,
    },
  ]);

  const [config, setConfig] = useState({
    potenciaPanel: 655,
    hsp: 6.01,
    eficiencia: 0.8,
    usdMx: 17.88,
    precioMin: 1.11,
    precioMax: 1.32,
  });

  const [resultados, setResultados] = useState(null);

  // --- NUEVOS ESTADOS PARA ALMACENAMIENTO (BESS) ---
  const [subModoBESS, setSubModoBESS] = useState("hibrido"); // hibrido, offgrid
  const [perfilCargas, setPerfilCargas] = useState("2500");
  const [cargasPersonalizadasW, setCargasPersonalizadasW] = useState("");
  const [horasAutonomia, setHorasAutonomia] = useState("6");
  const [tieneSolar, setTieneSolar] = useState(true);
  const [diasAutonomia, setDiasAutonomia] = useState("1");

  // 🔴🔴🔴 TU API KEY DE GOOGLE 🔴🔴🔴
  const apiKey = "AIzaSyBRC0xarGTT25zc5RCyatkFSFjd3Dsn6kM";

  // --- LÓGICA DE RECIBOS ---
  const handlePeriodoChange = (index, value) => {
    const newPeriodos = [...periodos];
    newPeriodos[index] = value;
    setPeriodos(newPeriodos);
  };

  const handleTipoPeriodoChange = (e) => {
    const nuevoTipo = e.target.value;
    setTipoPeriodo(nuevoTipo);
    if (nuevoTipo === "Mensual" && periodos.length < 12) {
      setPeriodos([...periodos, ...Array(12 - periodos.length).fill("")]);
    } else if (nuevoTipo === "Bimestral" && periodos.length > 6) {
      setPeriodos(periodos.slice(0, 6));
    }
  };

  // ============================================================
  // LLAMADA 1: GEMINI 2.5 FLASH LITE — OCR PURO
  // ============================================================
  const handleFileUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (!files || files.length === 0) return;
    if (!apiKey) {
      alert("API Key requerida");
      return;
    }

    setScanStatus("analyzing");
    try {
      const fileToGenerativePart = async (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64Data = reader.result.split(",")[1];
            resolve({ inlineData: { data: base64Data, mimeType: file.type } });
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      const imageParts = await Promise.all(files.map(fileToGenerativePart));

      const urlFlash = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash-lite:generateContent?key=${apiKey}`;

      const payloadOCR = {
        contents: [
          {
            role: "user",
            parts: [
              {
                text: `Eres un experto en leer recibos de CFE México. Tu única tarea es extraer datos estructurados. Devuelve ÚNICAMENTE un JSON válido. Sin markdown, sin comillas invertidas, sin texto adicional.

ESTRUCTURA EXACTA DEL JSON:
{
  "cliente": "",
  "primerNombre": "",
  "colonia": "",
  "ubicacion": "",
  "tarifa": "",
  "montoActual": 0,
  "consumoActual": 0,
  "periodoFacturadoInicio": "",
  "periodoFacturadoFin": "",
  "tipoPeriodo": "",
  "bloquesConsumo": [],
  "periodos": []
}

INSTRUCCIONES CAMPO POR CAMPO:
"cliente": El nombre completo tal como aparece en el recibo en mayúsculas.
"primerNombre": En los recibos CFE el formato es APELLIDO1 APELLIDO2 NOMBRE. El primer nombre de pila es la TERCERA palabra. Ponlo en Title Case.
"colonia": El nombre de la colonia o fraccionamiento donde vive el cliente. Solo el nombre de la colonia, sin calle ni número.
"ubicacion": ÚNICAMENTE el nombre de la ciudad. Ejemplo: "CD OBREGON, Son." → "Obregón". Solo la ciudad.
"tarifa": La clave de tarifa exacta.
"montoActual": El número del TOTAL A PAGAR. Solo el número.
"consumoActual": En la tabla principal de la HOJA 1, busca la fila "Energía (kWh)" y toma el valor de la columna "Total periodo".
"periodoFacturadoInicio": La fecha de inicio (DD/MM/AAAA).
"periodoFacturadoFin": La fecha de fin (DD/MM/AAAA).
"tipoPeriodo": Calcula la diferencia en días entre periodoFacturadoFin y periodoFacturadoInicio. Si es > 45 días → "Bimestral". Si <= 45 días → "Mensual".
"bloquesConsumo": Array con los bloques tarifarios.
"periodos": Array con consumos. periodos[0] = consumoActual. Desde periodos[1] usa CONSUMO HISTÓRICO leyendo desde el más reciente al más antiguo. No dupliques el actual.`,
              },
              ...imageParts,
            ],
          },
        ],
        generationConfig: {
          responseMimeType: "application/json",
        },
      };

      const resOCR = await fetch(urlFlash, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payloadOCR),
      });

      if (!resOCR.ok) throw new Error("Error en API de Google");
      const resultOCR = await resOCR.json();

      let rawText = resultOCR.candidates[0].content.parts[0].text
        .replace(/```json/g, "")
        .replace(/```/g, "")
        .trim();

      const data = JSON.parse(rawText);

      if (data.cliente) setCliente(data.cliente);
      if (data.primerNombre) setPrimerNombre(data.primerNombre);
      if (data.colonia) setColonia(data.colonia);
      setUbicacion(data.ubicacion || "");
      if (data.tarifa) setTarifa(data.tarifa);
      if (data.montoActual) setMontoActual(data.montoActual);
      if (data.bloquesConsumo && Array.isArray(data.bloquesConsumo))
        setBloquesConsumo(data.bloquesConsumo);

      const isMensual = data.tipoPeriodo === "Mensual";
      setTipoPeriodo(isMensual ? "Mensual" : "Bimestral");

      if (data.periodos && Array.isArray(data.periodos)) {
        const size = isMensual ? 12 : 6;
        const newPeriodos = Array(size).fill("");
        data.periodos.forEach((val, idx) => {
          if (idx < size) newPeriodos[idx] = val;
        });
        setPeriodos(newPeriodos);
      }

      setScanStatus("success");
      setTimeout(() => setScanStatus(""), 3000);
    } catch (error) {
      alert(`⚠️ Error de lectura: ${error.message}`);
      setScanStatus("error");
      setTimeout(() => setScanStatus(""), 4000);
    }
    event.target.value = null;
  };

  // --- LÓGICA DE CARGAS ---
  const agregarCarga = () => {
    const newId =
      cargas.length > 0 ? Math.max(...cargas.map((c) => c.id)) + 1 : 1;
    setCargas([
      ...cargas,
      { id: newId, aparato: "", cantidad: 1, watts: 0, horas: 0, mesesAno: 12 },
    ]);
  };
  const eliminarCarga = (id) => setCargas(cargas.filter((c) => c.id !== id));
  const updateCarga = (id, field, value) =>
    setCargas(cargas.map((c) => (c.id === id ? { ...c, [field]: value } : c)));

  const calcularConsumoCargas = () => {
    let consumo = 0;
    cargas.forEach((c) => {
      consumo +=
        ((Number(c.watts) || 0) *
          (Number(c.cantidad) || 0) *
          (Number(c.horas) || 0) *
          365 *
          ((Number(c.mesesAno) || 0) / 12)) /
        1000;
    });
    return consumo;
  };

  const handleConfigChange = (key, value) =>
    setConfig({ ...config, [key]: Number(value) });

  // ============================================================
  // LLAMADA 2: GEMINI 2.5 PRO — GUION RECIBOS
  // ============================================================
  const generarGuionConPro = async (datosParaGuion) => {
    const urlPro = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-pro:generateContent?key=${apiKey}`;
    const {
      primerNombreCliente,
      coloniaCliente,
      ciudadCliente,
      isForaneo,
      montoRecibo,
      tipoPeriodoCliente,
      consumoActualKwh,
      consumoMismoMesAnioAnterior,
      numPaneles,
      potenciaPanel,
      minMxn,
      maxMxn,
      bloquesDetalle,
      cierreAgenda,
    } = datosParaGuion;

    const excedente = bloquesDetalle.find((b) =>
      b.nombre?.toLowerCase().includes("excedente"),
    );
    const tieneExcedenteSignificativo =
      excedente && Number(excedente.kwh) > 100;
    const tieneComparativa =
      consumoMismoMesAnioAnterior && consumoMismoMesAnioAnterior > 0;
    const variacionPct = tieneComparativa
      ? Math.round(
          ((consumoActualKwh - consumoMismoMesAnioAnterior) /
            consumoMismoMesAnioAnterior) *
            100,
        )
      : 0;

    const mes = new Date().getMonth() + 1;
    const esPreVerano = mes >= 3 && mes <= 5;
    const esVerano = mes >= 6 && mes <= 9;
    let contextoEstacional = esPreVerano
      ? "IMPORTANTE: Estamos en pre-verano. Usa esto como urgencia."
      : esVerano
        ? "IMPORTANTE: Estamos en pleno verano."
        : "Estamos en temporada baja, buen momento para instalar.";

    const promptGuion = `Eres el Director Comercial de Sintergia Energy, empresa de ingeniería solar en México. Escribes para WhatsApp: persuasivo, cálido, sin emojis corporativos.
DATOS: ${primerNombreCliente}, ${ciudadCliente}, ${tipoPeriodoCliente}, Consumo: ${consumoActualKwh}kWh. Monto: $${Number(montoRecibo).toLocaleString()}
DIMENSIONAMIENTO: ${numPaneles} paneles de ${potenciaPanel}W. Rango: $${Math.round(minMxn).toLocaleString()} – $${Math.round(maxMxn).toLocaleString()} pesos.
CONTEXTO: ${contextoEstacional}
CIERRE: ${cierreAgenda}
Genera el guion mencionando ahorro, congelar costo a 25 años y enganche del 5%. Máximo 4 párrafos.`;

    const resPro = await fetch(urlPro, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        contents: [{ role: "user", parts: [{ text: promptGuion }] }],
      }),
    });

    if (!resPro.ok) throw new Error("Error en Gemini Pro");
    const resultPro = await resPro.json();
    return resultPro.candidates[0].content.parts[0].text.trim();
  };

  // ============================================================
  // LLAMADA 3: GEMINI 2.5 PRO — GUION ALMACENAMIENTO (NUEVO)
  // ============================================================
  const generarGuionBESSConPro = async (datos) => {
    const urlPro = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-pro:generateContent?key=${apiKey}`;
    const promptBESS = `Eres el Director Comercial de Sintergia Energy en Sonora, México. Vendes sistemas de ingeniería de alto valor. Escribes para WhatsApp a un prospecto llamado ${datos.primerNombreCliente}.
El prospecto solicitó un sistema de Baterías (BESS) en modalidad: ${datos.subModoBESS === "hibrido" ? "Híbrida (Respaldo ante apagones)" : "100% Off-Grid (Aislado de la red)"}.

HARDWARE PROPUESTO:
- Baterías: ${datos.descBateria}
- Inversor: ${datos.descInversor}
- Inversión llave en mano: $${Math.round(datos.minMxn).toLocaleString()} a $${Math.round(datos.maxMxn).toLocaleString()} MXN.

INSTRUCCIÓN CRÍTICA DE VENTA: 
El dolor del cliente NO es solo "quedarse a oscuras". En Sonora, un apagón de CFE significa quedarse sin aire acondicionado a 40°C+. Posiciona esta batería Fortress Power y el inversor Lux Power como un seguro de confort, resiliencia y protección familiar ante el calor extremo. 

Estructura el mensaje de WhatsApp (3 o 4 párrafos):
1. Saludo a ${datos.primerNombreCliente} y mención del calor/apagones.
2. Presenta la solución técnica (menciona las marcas premium Fortress y Lux Power).
3. Da el rango de inversión y menciona financiamiento desde el 5%.
4. Cierra con la pregunta exacta: "${datos.cierreAgenda}"
Sin emojis excesivos, tono de ingeniero experto y asesor.`;

    const resPro = await fetch(urlPro, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        contents: [{ role: "user", parts: [{ text: promptBESS }] }],
      }),
    });
    const resultPro = await resPro.json();
    return resultPro.candidates[0].content.parts[0].text.trim();
  };

  // ============================================================
  // CALCULAR PROYECTO
  // ============================================================
  const calcularProyecto = async () => {
    // ── Formatear nombre y cierres ──
    const formatName = (str) => {
      if (!str) return "";
      return str
        .split(" ")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(" ");
    };
    const nombreMostrar = primerNombre
      ? primerNombre
      : (() => {
          const palabras = formatName(cliente).split(" ");
          return palabras.length >= 3 ? palabras[2] : palabras[0];
        })();
    const ciudadFormateada = formatName(ubicacion);
    const coloniaFormateada = formatName(colonia);
    const isMissing = ubicacion.trim() === "";
    const isForaneo =
      !isMissing &&
      !["obregón", "obregon", "cd obregón", "cd obregon"].includes(
        ubicacion.trim().toLowerCase(),
      );

    const obtenerCierre = (foraneo) => {
      const dia = new Date().getDay();
      const accion = foraneo ? "esa llamadita" : "esa visita";
      const nombres = [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ];
      if (dia >= 1 && dia <= 3)
        return `¿Cómo andas de tiempo mañana o el ${nombres[dia + 2]} para ${accion}?`;
      else if (dia === 4)
        return `¿Te acomoda mañana o el lunes para ${accion}?`;
      else return `¿Cómo andas el lunes o el martes para ${accion}?`;
    };
    const cierreAgenda = obtenerCierre(isForaneo);

    // ==========================================
    // RUTA 1: ALMACENAMIENTO (BESS)
    // ==========================================
    if (modoCalculo === "almacenamiento") {
      if (isMissing) {
        setResultados({
          isMissingLocation: true,
          script: "[UBICACIÓN REQUERIDA]",
        });
        return;
      }

      // Constantes de Ingeniería
      const DOD = 0.8;
      const EFF_INV = 0.96;
      const RTE_BAT = 0.98;
      const COSTO_EFLEX = 888;
      const COSTO_EVAULT = 9145;
      const COSTO_LUX12K = 4500;
      const COSTO_BOS_WATT = 1.5;

      let wattsPico = 0;
      let kWhRequeridos = 0;
      let panelesBESS = 0;
      let wDiarios = 0;

      if (subModoBESS === "hibrido") {
        wattsPico =
          perfilCargas === "personalizado"
            ? Number(cargasPersonalizadasW)
            : Number(perfilCargas);
        if (wattsPico <= 0) {
          alert("Ingresa la potencia para el respaldo.");
          return;
        }
        kWhRequeridos =
          (wattsPico * Number(horasAutonomia)) /
          1000 /
          (DOD * EFF_INV * RTE_BAT);
      } else {
        const consumoAnual = calcularConsumoCargas();
        if (consumoAnual === 0) {
          alert("Agrega equipos al cuadro de cargas.");
          return;
        }
        const consumoDiarioKwh = consumoAnual / 365;
        kWhRequeridos =
          (consumoDiarioKwh * Number(diasAutonomia)) /
          (DOD * EFF_INV * RTE_BAT);

        cargas.forEach(
          (c) => (wattsPico += Number(c.watts) * Number(c.cantidad)),
        );
        wDiarios = consumoDiarioKwh * 1000;
        const generacionPanel =
          config.potenciaPanel * config.hsp * config.eficiencia;
        panelesBESS = Math.ceil((wDiarios * 1.25) / generacionPanel);
      }

      // Hardware Baterías
      let numBaterias = 0;
      let descBateria = "";
      let descBateriaCorto = "";
      let costoBaterias = 0;

      if (kWhRequeridos <= 21 && wattsPico / 48 <= 180) {
        numBaterias = Math.ceil(kWhRequeridos / 5.4);
        if (numBaterias === 0) numBaterias = 1;
        descBateria = `${numBaterias}x Módulo(s) Fortress eFlex (5.4 kWh)`;
        descBateriaCorto = `${numBaterias}x eFlex`;
        costoBaterias = numBaterias * COSTO_EFLEX;
      } else {
        numBaterias = Math.ceil(kWhRequeridos / 18.5);
        if (numBaterias === 0) numBaterias = 1;
        descBateria = `${numBaterias}x Gabinete(s) Fortress eVault Max (18.5 kWh)`;
        descBateriaCorto = `${numBaterias}x eVault Max`;
        costoBaterias = numBaterias * COSTO_EVAULT;
      }

      // Hardware Inversor
      let descInversor = "";
      if (wattsPico <= 3600) descInversor = "Lux Power LXP-3600";
      else if (wattsPico <= 5000) descInversor = "Lux Power LXP-5000";
      else if (wattsPico <= 6000) descInversor = "Lux Power LXP-6000";
      else if (wattsPico <= 12000) descInversor = "Lux Power LXP-12000";
      else descInversor = "2x Lux Power LXP-12000 (Paralelo)";

      let costoInversor = COSTO_LUX12K;
      let costoPaneles =
        panelesBESS > 0
          ? panelesBESS * config.potenciaPanel * COSTO_BOS_WATT
          : 0;
      let costoBaseUSD = costoInversor + costoBaterias + costoPaneles;

      if (subModoBESS === "hibrido" && !tieneSolar) {
        costoBaseUSD *= 1.3; // Agregar BOS solar estimado
      }

      const minMxnBESS = costoBaseUSD * config.usdMx * 0.95;
      const maxMxnBESS = costoBaseUSD * config.usdMx * 1.1;

      setResultados({
        esBESS: true,
        kWhRequeridos,
        descBateriaCorto,
        wattsPico,
        panelesBESS,
        minMxn: minMxnBESS,
        maxMxn: maxMxnBESS,
        script: "✍️ Generando guion de resiliencia BESS...",
        isForaneo,
        isMissingLocation: false,
        generandoGuion: true,
      });

      try {
        const guionBESS = await generarGuionBESSConPro({
          primerNombreCliente: nombreMostrar,
          subModoBESS,
          descBateria,
          descInversor,
          minMxn: minMxnBESS,
          maxMxn: maxMxnBESS,
          cierreAgenda,
        });
        setResultados((prev) => ({
          ...prev,
          script: guionBESS,
          generandoGuion: false,
        }));
      } catch (e) {
        setResultados((prev) => ({
          ...prev,
          script: "Error generando guion BESS. Intenta de nuevo.",
          generandoGuion: false,
        }));
      }
      return;
    }

    // ==========================================
    // RUTA 2: RECIBOS Y CARGAS ORIGINALES
    // ==========================================
    let consumoAnual =
      modoCalculo === "recibo"
        ? periodos.reduce((acc, curr) => acc + (Number(curr) || 0), 0)
        : calcularConsumoCargas();
    if (consumoAnual === 0) {
      alert("Ingresa datos válidos.");
      return;
    }

    const wDiarios = (consumoAnual * 1000) / 365;
    const generacionPanel =
      config.potenciaPanel * config.hsp * config.eficiencia;
    const numPaneles = Math.ceil(wDiarios / generacionPanel);
    const wattsSistema = numPaneles * config.potenciaPanel;
    const minMxn = wattsSistema * config.precioMin * config.usdMx;
    const maxMxn = wattsSistema * config.precioMax * config.usdMx;

    if (isMissing) {
      setResultados({
        consumoAnual,
        numPaneles,
        minMxn,
        maxMxn,
        script: "[UBICACIÓN NO ESPECIFICADA]",
        isForaneo,
        isMissingLocation: true,
      });
      return;
    }

    if (modoCalculo === "cargas") {
      const scriptCargas = `¡Qué tal ${nombreMostrar}! Un placer saludarte...\n\nProyectamos ${Math.round(consumoAnual)} kWh anuales.\n\nInversión: $${Math.round(minMxn).toLocaleString()} a $${Math.round(maxMxn).toLocaleString()}\n\n${cierreAgenda}`;
      setResultados({
        esBESS: false,
        consumoAnual,
        numPaneles,
        minMxn,
        maxMxn,
        script: scriptCargas,
        isForaneo,
        isMissingLocation: false,
      });
      return;
    }

    setResultados({
      esBESS: false,
      consumoAnual,
      numPaneles,
      minMxn,
      maxMxn,
      script: "✍️ Generando guion...",
      isForaneo,
      isMissingLocation: false,
      generandoGuion: true,
    });

    try {
      const consumoActualKwh = Number(periodos[0]) || 0;
      const idxAnioAnterior = tipoPeriodo === "Mensual" ? 12 : 6;
      const consumoMismoMesAnioAnterior =
        periodos.length > idxAnioAnterior
          ? Number(periodos[idxAnioAnterior]) || 0
          : 0;

      const guion = await generarGuionConPro({
        primerNombreCliente: nombreMostrar,
        coloniaCliente: coloniaFormateada,
        ciudadCliente: ciudadFormateada,
        isForaneo,
        montoRecibo: montoActual,
        tipoPeriodoCliente: tipoPeriodo,
        consumoActualKwh,
        consumoMismoMesAnioAnterior,
        numPaneles,
        potenciaPanel: config.potenciaPanel,
        minMxn,
        maxMxn,
        bloquesDetalle: bloquesConsumo,
        cierreAgenda,
      });
      setResultados((prev) => ({
        ...prev,
        script: guion,
        generandoGuion: false,
      }));
    } catch (error) {
      setResultados((prev) => ({
        ...prev,
        script: "Error generando guion. Intenta de nuevo.",
        generandoGuion: false,
      }));
    }
  };

  const copiar = () => {
    if (
      resultados?.script &&
      !resultados.isMissingLocation &&
      !resultados.generandoGuion
    ) {
      navigator.clipboard.writeText(resultados.script).then(() => {
        const btn = document.getElementById("copyBtn");
        if (btn) {
          btn.innerText = "¡Copiado!";
          btn.style.backgroundColor = "#25d366";
          setTimeout(() => {
            btn.innerText = "Copiar Guion";
            btn.style.backgroundColor = "";
          }, 2000);
        }
      });
    }
  };

  // ==========================================
  // RENDER UI
  // ==========================================
  return (
    <div className="sintergia-app-wrapper min-h-screen p-4 md:p-8 text-slate-800">
      <div className="max-w-6xl mx-auto">
        {/* HEADER CRISTAL CON NUEVA PESTAÑA */}
        <header className="glass-header mb-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <img
              src={miLogo}
              alt="Sintergia"
              className="h-12 w-auto object-contain drop-shadow-md"
            />
            <div className="border-l border-white/40 pl-4 hidden sm:block">
              <h1
                className="text-2xl font-bold text-slate-800 tracking-tight"
                style={{ textShadow: "0 1px 2px rgba(255,255,255,0.8)" }}
              >
                Hub Comercial
              </h1>
            </div>
          </div>

          <div className="flex flex-wrap gap-2 w-full sm:w-auto justify-center">
            <button
              onClick={() => {
                setModoCalculo("recibo");
                setResultados(null);
              }}
              className={`flex-1 sm:flex-none sintergia-tab ${modoCalculo === "recibo" ? "active" : ""}`}
            >
              🧾 Recibo CFE
            </button>
            <button
              onClick={() => {
                setModoCalculo("cargas");
                setResultados(null);
              }}
              className={`flex-1 sm:flex-none sintergia-tab ${modoCalculo === "cargas" ? "active" : ""}`}
            >
              🏗️ Construcción
            </button>
            {/* NUEVA PESTAÑA BESS */}
            <button
              onClick={() => {
                setModoCalculo("almacenamiento");
                setResultados(null);
              }}
              className={`flex-1 sm:flex-none sintergia-tab ${modoCalculo === "almacenamiento" ? "active !bg-slate-800 !border-slate-900 !text-white !shadow-lg" : ""}`}
            >
              🔋 Almacenamiento
            </button>
          </div>
        </header>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          {/* COLUMNA IZQUIERDA: INPUTS */}
          <div className="lg:col-span-5 space-y-6">
            <div className="glass-card p-6">
              <div className="flex justify-between items-center mb-4 border-b border-black/5 pb-4">
                <h2 className="text-xl font-semibold text-slate-800">
                  1. Datos del Prospecto
                </h2>
                {modoCalculo === "recibo" && (
                  <label
                    className={`cursor-pointer text-xs font-bold py-2 px-3 rounded-xl border transition-all shadow-sm flex items-center gap-2 ${scanStatus === "analyzing" ? "border-gray-300 text-gray-500 bg-white/50" : scanStatus === "success" ? "border-green-400 text-green-600 bg-green-50" : "border-[#fc7101] text-[#fc7101] bg-white/50 hover:bg-[#fc7101] hover:text-white"}`}
                  >
                    {scanStatus === "analyzing"
                      ? "Analizando..."
                      : scanStatus === "success"
                        ? "✅ Listo"
                        : "🤖 Escanear"}
                    <input
                      type="file"
                      multiple
                      accept="image/*,application/pdf"
                      onChange={handleFileUpload}
                      className="hidden"
                      disabled={scanStatus === "analyzing"}
                    />
                  </label>
                )}
              </div>

              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-600 mb-1">
                    Nombre del Cliente
                  </label>
                  <input
                    type="text"
                    value={cliente}
                    onChange={(e) => setCliente(e.target.value)}
                    placeholder="Ej. MORALES CAMPA HUGO ALBERTO"
                    className="sintergia-input"
                  />
                </div>
                <div
                  className={
                    modoCalculo === "recibo" ? "grid grid-cols-2 gap-4" : ""
                  }
                >
                  <div>
                    <label className="block text-sm font-medium text-slate-600 mb-1">
                      Ubicación (Ciudad)
                    </label>
                    <input
                      type="text"
                      value={ubicacion}
                      onChange={(e) => setUbicacion(e.target.value)}
                      placeholder="Ej. Obregón"
                      className={`sintergia-input ${ubicacion === "" ? "!border-red-400 !bg-red-50" : ""}`}
                    />
                  </div>
                  {modoCalculo === "recibo" && (
                    <div>
                      <label className="block text-sm font-medium text-slate-600 mb-1">
                        Tarifa CFE
                      </label>
                      <select
                        value={tarifa}
                        onChange={(e) => setTarifa(e.target.value)}
                        className="sintergia-input"
                      >
                        <option value="1F">Tarifa 1F</option>
                        <option value="DAC">Tarifa DAC</option>
                        <option value="PDBT">PDBT (Negocio)</option>
                      </select>
                    </div>
                  )}
                </div>
                {modoCalculo === "recibo" && (
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="block text-sm font-medium text-slate-600 mb-1">
                        Monto Último Recibo
                      </label>
                      <input
                        type="number"
                        value={montoActual}
                        onChange={(e) => setMontoActual(e.target.value)}
                        placeholder="Ej. 9963"
                        className="sintergia-input"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-600 mb-1">
                        Facturación
                      </label>
                      <select
                        value={tipoPeriodo}
                        onChange={handleTipoPeriodoChange}
                        className="sintergia-input text-[#fc7101] font-bold"
                      >
                        <option value="Bimestral">Bimestral</option>
                        <option value="Mensual">Mensual</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* SECCIÓN 2 DINÁMICA DEPENDIENDO DEL MODO */}
            <div className="glass-card p-6">
              {modoCalculo === "recibo" && (
                <>
                  <h2 className="text-xl font-semibold text-slate-800 mb-2 border-b border-black/5 pb-2">
                    2. Historial de Consumo
                  </h2>
                  <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mt-4">
                    {periodos.map((val, index) => (
                      <div key={index}>
                        <label className="block text-xs font-medium text-slate-500 mb-1">
                          Periodo {index + 1}
                        </label>
                        <input
                          type="number"
                          value={val}
                          onChange={(e) =>
                            handlePeriodoChange(index, e.target.value)
                          }
                          className="sintergia-input !h-10 text-center text-sm"
                        />
                      </div>
                    ))}
                  </div>
                </>
              )}

              {/* LÓGICA DE INTERFAZ BESS */}
              {modoCalculo === "almacenamiento" && (
                <>
                  <h2 className="text-xl font-semibold text-slate-800 mb-4 border-b border-black/5 pb-2">
                    2. Ingeniería de Baterías
                  </h2>

                  <div className="flex gap-2 mb-6 bg-slate-100 p-1 rounded-xl">
                    <button
                      onClick={() => setSubModoBESS("hibrido")}
                      className={`flex-1 py-2 rounded-lg font-bold text-sm transition-all ${subModoBESS === "hibrido" ? "bg-white text-[#fc7101] shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
                    >
                      Híbrido (Apagones)
                    </button>
                    <button
                      onClick={() => setSubModoBESS("offgrid")}
                      className={`flex-1 py-2 rounded-lg font-bold text-sm transition-all ${subModoBESS === "offgrid" ? "bg-slate-800 text-white shadow-sm" : "text-slate-500 hover:text-slate-700"}`}
                    >
                      100% Off-Grid
                    </button>
                  </div>

                  {subModoBESS === "hibrido" ? (
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-slate-600 mb-1">
                          Perfil de Cargas Críticas
                        </label>
                        <select
                          value={perfilCargas}
                          onChange={(e) => setPerfilCargas(e.target.value)}
                          className="sintergia-input font-medium"
                        >
                          <option value="1000">
                            Esencial (1,000W) - Refri, Wi-Fi, Focos
                          </option>
                          <option value="2500">
                            Confort (2,500W) - Esencial + 1 Minisplit
                          </option>
                          <option value="4500">
                            Premium (4,500W) - Esencial + 2 Minisplits
                          </option>
                          <option value="personalizado">
                            Personalizado (Ingresar Watts)
                          </option>
                        </select>
                        {perfilCargas === "personalizado" && (
                          <input
                            type="number"
                            placeholder="Watts totales simultáneos..."
                            value={cargasPersonalizadasW}
                            onChange={(e) =>
                              setCargasPersonalizadasW(e.target.value)
                            }
                            className="sintergia-input mt-2 border-[#fc7101]"
                          />
                        )}
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-slate-600 mb-1">
                          Horas a Sobrevivir sin CFE
                        </label>
                        <select
                          value={horasAutonomia}
                          onChange={(e) => setHorasAutonomia(e.target.value)}
                          className="sintergia-input"
                        >
                          <option value="4">4 Horas (Apagón rápido)</option>
                          <option value="6">6 Horas (Estándar)</option>
                          <option value="8">8 Horas (Apagón severo)</option>
                        </select>
                      </div>
                      <div className="flex items-center gap-3 mt-5 p-3 bg-blue-50/50 rounded-xl border border-blue-100">
                        <input
                          type="checkbox"
                          checked={tieneSolar}
                          onChange={(e) => setTieneSolar(e.target.checked)}
                          className="w-5 h-5 accent-[#fc7101]"
                        />
                        <label className="text-sm font-medium text-slate-700">
                          El prospecto YA cuenta con paneles
                        </label>
                      </div>
                    </div>
                  ) : (
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-medium text-slate-600 mb-1">
                          Días de Autonomía (Sin Sol)
                        </label>
                        <select
                          value={diasAutonomia}
                          onChange={(e) => setDiasAutonomia(e.target.value)}
                          className="sintergia-input"
                        >
                          <option value="1">1 Día (Común en Sonora)</option>
                          <option value="2">2 Días (Conservador)</option>
                          <option value="3">3 Días (Crítico)</option>
                        </select>
                      </div>
                    </div>
                  )}
                </>
              )}

              {/* RENDER CUADRO DE CARGAS */}
              {(modoCalculo === "cargas" ||
                (modoCalculo === "almacenamiento" &&
                  subModoBESS === "offgrid")) && (
                <div
                  className={
                    modoCalculo === "almacenamiento"
                      ? "mt-6 border-t border-black/10 pt-4"
                      : ""
                  }
                >
                  {modoCalculo === "cargas" && (
                    <h2 className="text-xl font-semibold text-slate-800 mb-4 border-b border-black/5 pb-2">
                      2. Cuadro de Cargas
                    </h2>
                  )}
                  {modoCalculo === "almacenamiento" && (
                    <h3 className="text-sm font-bold text-[#fc7101] mb-3 uppercase tracking-wide">
                      Levantamiento de Cargas
                    </h3>
                  )}

                  <div className="space-y-4">
                    {cargas.map((carga) => (
                      <div
                        key={carga.id}
                        className="relative group bg-white/40 border border-white/60 rounded-xl p-3 shadow-sm"
                      >
                        <button
                          onClick={() => eliminarCarga(carga.id)}
                          className="absolute -top-2 -right-2 bg-red-100 text-red-500 rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-500 hover:text-white"
                        >
                          ✕
                        </button>
                        <div className="mb-2">
                          <input
                            type="text"
                            value={carga.aparato}
                            onChange={(e) =>
                              updateCarga(carga.id, "aparato", e.target.value)
                            }
                            placeholder="Aparato (Ej. Minisplit)"
                            className="w-11/12 bg-transparent font-semibold border-b border-black/10 focus:border-[#fc7101] outline-none text-sm pb-1"
                          />
                        </div>
                        <div className="grid grid-cols-4 gap-2 text-xs">
                          <div>
                            <label className="block text-slate-500 mb-1 text-center">
                              Cant.
                            </label>
                            <input
                              type="number"
                              value={carga.cantidad}
                              onChange={(e) =>
                                updateCarga(
                                  carga.id,
                                  "cantidad",
                                  e.target.value,
                                )
                              }
                              className="sintergia-input !px-1 !py-1 !h-auto text-center"
                            />
                          </div>
                          <div>
                            <label className="block text-slate-500 mb-1 text-center">
                              Watts
                            </label>
                            <input
                              type="number"
                              value={carga.watts}
                              onChange={(e) =>
                                updateCarga(carga.id, "watts", e.target.value)
                              }
                              className="sintergia-input !px-1 !py-1 !h-auto text-center"
                            />
                          </div>
                          <div>
                            <label className="block text-slate-500 mb-1 text-center">
                              Hrs/día
                            </label>
                            <input
                              type="number"
                              value={carga.horas}
                              onChange={(e) =>
                                updateCarga(carga.id, "horas", e.target.value)
                              }
                              className="sintergia-input !px-1 !py-1 !h-auto text-center"
                            />
                          </div>
                          <div>
                            <label className="block text-slate-500 mb-1 text-center">
                              Mes/año
                            </label>
                            <input
                              type="number"
                              value={carga.mesesAno}
                              onChange={(e) =>
                                updateCarga(
                                  carga.id,
                                  "mesesAno",
                                  e.target.value,
                                )
                              }
                              className="sintergia-input !px-1 !py-1 !h-auto text-center"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  <button
                    onClick={agregarCarga}
                    className="w-full mt-4 py-2 border-2 border-dashed border-[#fc7101]/30 text-[#fc7101] rounded-xl text-sm font-bold hover:bg-[#fc7101]/10 transition-colors"
                  >
                    + Añadir Equipo
                  </button>
                </div>
              )}
            </div>

            <button
              onClick={calcularProyecto}
              className="sintergia-btn-orange w-full flex items-center justify-center gap-2"
            >
              🚀 Ejecutar Triage Comercial
            </button>
          </div>

          {/* COLUMNA DERECHA: RESULTADOS */}
          <div className="lg:col-span-7 space-y-6">
            {resultados ? (
              <div className="animate-fade-in space-y-6">
                {/* TARJETAS SUPERIORES DINÁMICAS (BESS vs TRADICIONAL) */}
                <div className="grid grid-cols-3 gap-4">
                  {resultados.esBESS ? (
                    <div className="glass-card p-4 text-center">
                      <p className="text-slate-500 font-medium text-[10px] uppercase tracking-wider">
                        Fortress Power
                      </p>
                      <p className="text-lg font-bold text-slate-800 mt-2 leading-tight">
                        {resultados.descBateriaCorto}
                      </p>
                      <p className="text-xs text-[#fc7101] font-bold mt-1">
                        ~{resultados.kwhRequeridos.toFixed(1)} kWh Útiles
                      </p>
                    </div>
                  ) : (
                    <div className="glass-card p-4 text-center">
                      <p className="text-slate-500 font-medium text-xs uppercase tracking-wider">
                        Paneles
                      </p>
                      <p className="text-3xl font-bold text-slate-800 mt-2">
                        {resultados.numPaneles}
                      </p>
                      <p className="text-xs text-[#fc7101] font-bold mt-1">
                        {config.potenciaPanel}W c/u
                      </p>
                    </div>
                  )}

                  {resultados.esBESS ? (
                    <div className="glass-card p-4 text-center">
                      <p className="text-slate-500 font-medium text-[10px] uppercase tracking-wider">
                        Inversor Lux Power
                      </p>
                      <p className="text-lg font-bold text-slate-800 mt-2 leading-tight">
                        LXP Series
                      </p>
                      <p className="text-xs text-slate-400 font-medium mt-1">
                        Pico: {resultados.wattsPico} W
                      </p>
                    </div>
                  ) : (
                    <div className="glass-card p-4 text-center">
                      <p className="text-slate-500 font-medium text-xs uppercase tracking-wider">
                        Demanda Anual
                      </p>
                      <p className="text-2xl font-bold text-slate-800 mt-3">
                        {Math.round(resultados.consumoAnual).toLocaleString()}
                      </p>
                      <p className="text-xs text-slate-400 font-medium mt-1">
                        kWh
                      </p>
                    </div>
                  )}

                  <div className="glass-card p-4 text-center bg-slate-900/90 text-white !border-slate-700">
                    <p className="text-slate-300 font-medium text-[10px] uppercase tracking-wider">
                      Inversión Estimada
                    </p>
                    <p className="text-lg font-bold text-green-400 mt-3">
                      ${Math.floor(resultados.minMxn / 1000)}k - $
                      {Math.floor(resultados.maxMxn / 1000)}k
                    </p>
                    <p className="text-[10px] text-slate-400 font-medium mt-1">
                      Pesos MXN
                    </p>
                  </div>
                </div>

                <div className="glass-card p-6 relative">
                  <div className="flex justify-between items-center mb-4 border-b border-black/5 pb-2">
                    <h2 className="text-xl font-semibold text-slate-800 flex items-center gap-2">
                      Guion de WhatsApp
                    </h2>
                  </div>

                  {resultados.generandoGuion ? (
                    <div className="flex flex-col items-center justify-center h-80 gap-4 text-slate-400">
                      <svg
                        className="animate-spin h-8 w-8 text-[#fc7101]"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                      <p className="text-sm font-medium">
                        Generando magia comercial con IA...
                      </p>
                    </div>
                  ) : (
                    <textarea
                      className="sintergia-textarea w-full h-80"
                      value={resultados.script}
                      readOnly
                    />
                  )}

                  {!resultados.isMissingLocation &&
                    !resultados.generandoGuion && (
                      <button
                        id="copyBtn"
                        onClick={copiar}
                        className="sintergia-btn-orange w-full mt-4"
                      >
                        Copiar Guion
                      </button>
                    )}
                </div>
              </div>
            ) : (
              <div className="glass-card h-full flex flex-col items-center justify-center p-12 text-slate-400 border-dashed border-2 border-slate-300/50">
                <p className="text-center text-sm">
                  Ingresa los datos y presiona el botón para generar el cálculo
                  y el guion.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&display=swap');
        .sintergia-app-wrapper { background: linear-gradient(135deg, #f8f9fa 0%, #edf2f7 100%); font-family: 'Poppins', sans-serif; }
        .glass-header { padding: 12px 36px; border-radius: 50px; background: rgba(255, 255, 255, 0.3); backdrop-filter: blur(25px); border: 1px solid rgba(255, 255, 255, 0.6); box-shadow: 0 4px 30px rgba(0,0,0,0.05); }
        .glass-card { background: rgba(255, 255, 255, 0.45); backdrop-filter: blur(20px); border: 1px solid rgba(255, 255, 255, 0.7); border-radius: 21.5px; box-shadow: 0 10px 30px rgba(0,0,0,0.04); }
        .sintergia-input { width: 100%; height: 50px; background: #f8f9fa; border: 1px solid #e5e7eb; border-radius: 12px; padding: 0 15px; font-size: 14px; outline: none; transition: all 0.3s ease; }
        .sintergia-textarea { background: #f8f9fa; border: 1px solid #e5e7eb; border-radius: 12px; padding: 15px; font-size: 14px; outline: none; resize: none; transition: all 0.3s ease; }
        .sintergia-input:focus, .sintergia-textarea:focus { border-color: #fc7101; background: #fff; box-shadow: 0 0 0 3px rgba(252, 113, 1, 0.1); }
        .sintergia-btn-orange { background-color: #fc7101; color: #ffffff; border: none; border-radius: 50px; padding: 15px 30px; font-weight: 600; font-size: 16px; box-shadow: 0 10px 20px rgba(252, 113, 1, 0.25); cursor: pointer; transition: all 0.3s ease; }
        .sintergia-btn-orange:hover { background-color: #e05e00; transform: translateY(-3px); box-shadow: 0 15px 30px rgba(252, 113, 1, 0.35); }
        .sintergia-tab { font-size: 14px; padding: 10px 25px; border-radius: 999px; cursor: pointer; transition: all 0.3s ease; color: #555; background-color: rgba(255, 255, 255, 0.6); border: 1px solid rgba(255, 255, 255, 0.8); font-weight: 500; }
        .sintergia-tab:hover:not(.active) { background-color: rgba(255, 255, 255, 0.95); border-color: rgba(252, 113, 1, 0.5); color: #fc7101; transform: translateY(-1px); }
        .sintergia-tab.active { background-color: rgba(252, 113, 1, 0.9); color: #ffffff; border-color: rgba(252, 113, 1, 1); box-shadow: 0 5px 10px rgba(252, 113, 1, 0.3); }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fade-in { animation: fadeIn 0.4s forwards; }
      `}</style>
    </div>
  );
}
